/* eslint-disable no-unused-expressions */
import { createSelector } from "reselect";
import { createMakeSelectCurrentPage } from "../../lib/providers/pagination-provider/selectors";
import { makeSelectQuestionnaires } from "../questionnaires/selectors";
import { makeSelectAllQuestions } from "../questions/selectors";
import { makeSelectQuestionnaireCategory } from "../questionnaireCategories/selectors";
import { makeSelectAnswerOptions } from "../answerOptions/selectors";

const selectProfileEntity = state => state.entities.user_answer;
const selectEntityData = state =>
  state.entities.user_answer ? state.entities.user_answer.data || {} : {};

export const makeSelectAllUserAnswers = paginationKey =>
  createSelector(
    [
      selectEntityData,
      createMakeSelectCurrentPage(paginationKey)(),
      makeSelectQuestionnaires(),
      makeSelectAllQuestions(),
      makeSelectQuestionnaireCategory(),
      makeSelectAnswerOptions()
    ],
    (substate, page, questionnaires, questions, categories, answerOptions) => {
      if (!paginationKey) {
        return { ...substate };
      }

      const data = {
        questionnaires: {},
        categories: {}
      };

      if (page.length > 0)
        page
          .forEach(id => {
            if (!substate[id]) {
              return null;
            }
            const answer = { ...substate[id] };

            answer.question = questions[answer.question.id];
            if (answer.closed_answer_id)
              answer.question.answer_options =
                answerOptions[answer.closed_answer_id];
            answer.questionnaire = questionnaires[answer.questionnaire_id];
            data.questionnaires[answer.questionnaire_id] = answer.questionnaire;
            answer.questionnaire_category =
              categories[answer.questionnaire_category.id];
            if (!data.categories[answer.questionnaire_category.id]) {
              data.categories[answer.questionnaire_category.id] = [];
            }

            data.categories[answer.questionnaire_category.id].push(answer);
            //console.warn(answer);
          })
          .filter(row => row);

      return data;
    }
  );

export const makeSelectUserAnswersError = () =>
  createSelector(selectProfileEntity, substate => {
    return substate.error;
  });

export const makeSelectIsUserAnswersLoading = () =>
  createSelector(selectProfileEntity, substate => {
    return substate ? substate.isLoading : false;
  });
